import api from 'api'

export type AddRequirementQuestionParams = {
  requirementId: number
  question: string
  idealAnswer: string
  evaluationCriteria: string
}

export const addRequirementQuestion = async ({
  requirementId,
  question,
  idealAnswer,
  evaluationCriteria,
}: AddRequirementQuestionParams): Promise<void> => {
  await api.post(`/admin/requirement/${requirementId}/question`, {
    question,
    idealAnswer,
    evaluationCriteria,
  })
}
